import * as TooltipPrimitive from '@radix-ui/react-tooltip';
import styled from 'styled-components';

export const MbjTooltipTrigger = styled(TooltipPrimitive.Trigger)((props) => ({
  all: 'unset',
}));
